import { useState } from 'react';
import { MdDescription } from 'react-icons/md';
import { Button } from '@/components/Button';
import ArrowDropDownIcon from '@/components/icons/ArrowDropDownIcon';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

type Item = {
  label: string;
  onSelect: () => void;
};

type Props = {
  variant: 'header' | 'timeline';
  items: Item[];
};

const VARIANTS = {
  header: {
    label: '面談情報',
    color: 'tertiary',
    size: 'sm',
    iconClassName: 'size-4',
    arrowClassName: 'size-3',
    align: 'end',
  },
  timeline: {
    label: '面談情報の追加',
    color: 'secondary',
    size: 'md',
    iconClassName: 'size-5',
    arrowClassName: 'size-4',
    align: 'start',
  },
} as const;

export default function CandidatesInterviewDropdown({ variant, items }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const config = VARIANTS[variant];

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen} modal={false}>
      <DropdownMenuTrigger asChild>
        <Button type="button" color={config.color} size={config.size} active={isOpen}>
          <MdDescription className={config.iconClassName} />
          {config.label}
          <ArrowDropDownIcon
            className={`${config.arrowClassName} transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={config.align}
        className="w-[163px] min-w-0 rounded-sm border-0 p-0 shadow-layer2"
      >
        {items.map((item) => (
          <DropdownMenuItem
            key={item.label}
            className="h-xxl cursor-pointer rounded-none px-sm py-xs text-body-sm text-main"
            onSelect={item.onSelect}
          >
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
